import mixpanel from 'mixpanel-browser'

export const trackListCreated = (listId) => {
  mixpanel.track('New Favorites List Was Created', {
    list_id: listId,
  })
}

export const trackListDeleted = (listId) => {
  mixpanel.track('New Favorites List Was Deleted', {
    list_id: listId,
  })
}

export const trackNewBikeAddedToFavorites = (bikeId, listId) => {
  mixpanel.track('Bike was added to favorites', {
    bike_id: bikeId,
    list_id: listId,
  })
}

export const trackNewBikeDeletedFavorites = (listId, bikeID) => {
  mixpanel.track('Bike was removed from favorites', {
    list_id: listId,
    bike_id: bikeID,
  })
}
